import { basicInitialState } from '../_utils/basicInitialState';
import { TAreaState } from './areasModel';

export const areasInitialState: TAreaState = {
  ...basicInitialState,
  areas: null,
  selectedAreas: [],
  zones: null
};
